import { memo } from "react";
import { ButtonLink } from "../../../components/buttons/button-link.tsx";
import { FontStyles } from "../../../utils/font-styles.ts";
import { cn } from "../../../utils/cn.ts";
import "../../../../assets/fa-icons/css/fontawesome.css";
import "../../../../assets/fa-icons/css/sharp-regular.css";

interface VirtualTourProps {
  url?: string;
  isVirtualTourExternalRedirect?: boolean;
}

export const VirtualTour = memo(({ url, isVirtualTourExternalRedirect }: VirtualTourProps) => {
  if (!url) return null;

  return isVirtualTourExternalRedirect ? (
    <div className="w-full h-full flex bg-neutral-50 items-center justify-center">
      <div className="flex flex-col justify-center items-center gap-5 text-center px-3.5">
        <p className={cn(FontStyles["body-l"], "text-slate")}>
          This virtual tour is hosted externally and will open in a new browser tab.
        </p>

        <ButtonLink
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-arrow-up-right-from-square" />}
          label="Open virtual tour"
          colorVariant="secondary"
          variant="solid"
        />
      </div>
    </div>
  ) : (
    <div className="w-full h-full flex bg-neutral-50 items-center justify-center">
      <iframe src={url} className="w-full h-full" allowFullScreen title="Virtual tour" />
    </div>
  );
});

VirtualTour.displayName = "VirtualTour";
